







































import appointments from '@/components/home/appointments.vue';
import customerExperienceDashboard from '@/components/home/customer-experience-dashboard.vue';
import dataCreationDashboard from '@/components/home/data-creation-dashboard.vue';
import partnerPracticeDashboard from '@/components/home/partner-practice-dashboard.vue';
import { RoleName } from '@/shared/role-name';
import { User } from '@/shared/user';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');

@Component({
    components: {
        appointments,
        customerExperienceDashboard,
        dataCreationDashboard,
        partnerPracticeDashboard,
    },
})
export default class Dashboard extends Vue {
    @userModule.Getter('user') private currentUser!: User | null;
    @userModule.Getter('isAdministrator') private isAdministrator!: boolean;
    @userModule.Getter('isInternalKeyStakeholder') private isInternalKeyStakeholder!: boolean;
    @userModule.Getter('isLegalAdvisor') private isLegalAdvisor!: boolean;

    private get showAppointments(): boolean {
        if (this.isAdministrator || this.isInternalKeyStakeholder) {
            return false;
        }

        return this.isLegalAdvisor;
    }


    private get showPartnerPracticeDashboard(): boolean {
        if (this.isAdministrator || this.isInternalKeyStakeholder) {
            return false;
        }

        return this.currentUser != null && this.currentUser.roles.some((role) =>
            (role.name.toLowerCase() === RoleName.HoD.toLowerCase() && this.currentUser!.partnerPracticeId != null) ||
            (role.name.toLowerCase() === RoleName.LegalAdvisor.toLowerCase() && this.currentUser!.partnerPracticeId != null) ||
            (role.name.toLowerCase() === RoleName.LegalAssistant.toLowerCase() && this.currentUser!.partnerPracticeId != null));
    }

    private get showCustomerExperienceDashboard(): boolean {
        if (this.isAdministrator || this.isInternalKeyStakeholder) {
            return false;
        }

        return this.currentUser != null && this.currentUser.roles.some((role) =>
            role.name.toLowerCase() === RoleName.CustomerExperienceExecutive.toLowerCase() ||
            role.name.toLowerCase() === RoleName.CustomerExperienceExecutiveTeamLeader.toLowerCase() ||
            role.name.toLowerCase() === RoleName.HeadOfCustomerExperienceTeam.toLowerCase());

    }

    private get showDataCreationDashboard(): boolean {
        if (this.isAdministrator || this.isInternalKeyStakeholder) {
            return false;
        }

        return this.currentUser != null && this.currentUser.roles.some((role) =>
            role.name.toLowerCase() === RoleName.DataCreationExecutive.toLowerCase() ||
            role.name.toLowerCase() === RoleName.DataCreationTeamLeader.toLowerCase());
    }
}
